export const fallbackAmazonFinds=[
  {
    id: 'fallback-santas-one-night-delivery',
    title: 'Santa’s One-Night Delivery',
    description: 'A magical Christmas colouring adventure exploring Santa, reindeer, elves, and gift delivery.',
    url: 'https://link.amazon/B0f10j9dN',
    image_url: 'https://m.media-amazon.com/images/W/BW_MEDIAX_AVIF_MEASUREMENT_1306696-T4/images/I/71uyttAeWRL._SL1293_.jpg',
    category: 'Books',
    price_label: 'View on Amazon',
    featured: 'TRUE',
    active: 'TRUE',
    order: 1
  },
  {
    id: 'fallback-insta360-luna-ultra',
    title: 'Insta360 Luna Ultra',
    description: '8K dual-Leica vlogging camera with 1-inch sensor, 12× zoom, and detachable touchscreen.',
    url: 'https://link.amazon/B060I6XAN',
    image_url: 'https://m.media-amazon.com/images/W/BW_MEDIAX_AVIF_MEASUREMENT_1306696-T4/images/I/61afnbb7BdL._AC_SL1500_.jpg',
    category: 'Cameras',
    price_label: 'View on Amazon',
    featured: 'TRUE',
    active: 'TRUE',
    order: 2
  },
  {
    id: 'fallback-dji-osmo-pocket-4p',
    title: 'DJI Osmo Pocket 4P',
    description: 'Dual-lens 4K vlog camera with 1-inch sensor, 12× zoom, and gimbal stabilization.',
    url: 'https://link.amazon/B05htaGHX',
    image_url: 'https://m.media-amazon.com/images/W/BW_MEDIAX_AVIF_MEASUREMENT_1306696-T4/images/I/61if3wIsNJL._AC_SL1500_.jpg',
    category: 'Cameras',
    price_label: 'View on Amazon',
    featured: 'TRUE',
    active: 'TRUE',
    order: 3
  },
  {
    id: 'fallback-insta360-x6-essentials-bundle',
    title: 'Insta360 X6 Essentials Bundle',
    description: '8K 360° action camera with dual sensors, AI editing, and 10-bit color.',
    url: 'https://link.amazon/B0f5GJnqe',
    image_url: 'https://m.media-amazon.com/images/I/61rfMiVXd2L._AC_SX679_.jpg',
    category: 'Cameras',
    price_label: 'View on Amazon',
    featured: 'TRUE',
    active: 'TRUE',
    order: 4
  }
];